export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_2FA_REQUEST = 'AUTH_2FA_REQUEST'
export const AUTH_2FA_RESEND_REQUEST = 'AUTH_2FA_RESEND_REQUEST'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_FORGOT = 'AUTH_FORGOT'
export const AUTH_RESET = 'AUTH_RESET'
export const AUTH_VALIDATE_RESET_TOKEN = 'AUTH_VALIDATE_RESET_TOKEN'
export const AUTH_SET_SUCCESS = 'AUTH_SET_SUCCESS'
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN'
export const AUTH_SESSION_KEEPALIVE = 'AUTH_SESSION_KEEPALIVE'
export const AUTH_CLEAR_TOKEN = 'AUTH_CLEAR_TOKEN'
export const AUTH_SET_ACCOUNT_TOKEN = 'AUTH_SET_ACCOUNT_TOKEN'



// WEBPACK FOOTER //
// ./src/store/actions/auth.js